import clsx from 'clsx';
import { SearchableDropdownOption } from '../index';

interface OptionsListProps {
  options: SearchableDropdownOption[];
  selectedValue: string | string[] | null;
  isMulti: boolean;
  highlightedIndex: number;
  setHighlightedIndex: (index: number) => void;
  onOptionClick: (value: string, label: string) => void;
  isShown: boolean;
}

export function OptionsList({
  options,
  selectedValue,
  isMulti,
  highlightedIndex,
  setHighlightedIndex,
  onOptionClick,
  isShown,
}: OptionsListProps) {
  if (!isShown) return null;

  return (
    <>
      {options.map((option, idx) => {
        const isSelected = isMulti
          ? Array.isArray(selectedValue) && selectedValue.includes(option.value)
          : option.value === selectedValue;

        return (
          <div
            key={option.value}
            id={`option-${idx}`}
            role="option"
            aria-selected={isSelected}
            tabIndex={-1}
            className={clsx(
              'flex cursor-pointer select-none items-center gap-2 rounded px-2 py-1',
              highlightedIndex === idx
                ? 'bg-fiona text-white'
                : isSelected
                  ? 'text-fiona font-semibold'
                  : 'font-normal text-gray-900',
            )}
            onMouseEnter={() => setHighlightedIndex(idx)}
            onClick={() => onOptionClick(option.value, option.label)}
          >
            <input
              type={isMulti ? 'checkbox' : 'radio'}
              checked={isSelected}
              readOnly
              className={clsx(
                'text-fiona h-4 w-4 border-gray-300',
                isMulti ? 'form-checkbox rounded' : 'form-radio',
              )}
              tabIndex={-1}
            />
            <span>{option.label}</span>
          </div>
        );
      })}
    </>
  );
}
